import ReactPaginate from "react-paginate";
import { Icon } from "@openedx/paragon";
import { ChevronLeft, ChevronRight } from '@openedx/paragon/icons';
import { getLocalizedFormattedNumber } from "../../utils/i18n";

const Pagination = ({ forcePage, pageCount, onPageChange, locale = 'en', ...props}) => {
  return (
    <ReactPaginate
      forcePage={forcePage}
      onPageChange={onPageChange}
      breakLabel='...'
      previousLabel={<Icon src={ChevronLeft} />}
      nextLabel={<Icon src={ChevronRight} />}
      pageCount={pageCount}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      className='react-paginate'
      breakClassName='break'
      activeClassName='active'
      pageLabelBuilder={((page) => getLocalizedFormattedNumber(page, locale))}
      {...props}
    />
  )
}

export default Pagination;